import { Wizard } from "src/app/core/wizard/wizard";
import {  Injectable } from "@angular/core";
import { StoreDetailReportComponent } from "./store-detail-report/store-detail-report.component";

@Injectable({
  providedIn: 'root'
})
export class RankByStorDetailReportWizard extends Wizard<any> {
  key = 'store-ranking-detail';
  pageTypeMap = {
    'store-ranking-detail': StoreDetailReportComponent,
  };

  startingPageKey = 'store-ranking-detail';
  hideHeader = true;
  hideFooter = true;
  backgroundColor = '#06091E';
  // height = '92vh';
  maxHeight = 'none';

  constructor() {
    super();
    this.width = 870;

  }


}
